import { render } from "./vue3-color-picker.vue?vue&type=template&id=496fca66&scoped=true"
import script from "./vue3-color-picker.vue?vue&type=script&lang=js"
export * from "./vue3-color-picker.vue?vue&type=script&lang=js"

import "./vue3-color-picker.vue?vue&type=style&index=0&id=496fca66&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\test\\html\\vue3-color-picker-gradient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496fca66"]])

export default __exports__